import {css} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";
import {replaceSpaceWithNonBreakingSpace} from "@pg-mono/string-utils";

import {HorizontalArticleList} from "../../../article/components/HorizontalArticleList";
import {IVendorDetailArticle} from "../../actions/fetch_vendor_detail_related_articles";

interface IProps {
    vendorName: string;
    articles: IVendorDetailArticle[];
}

export const VendorDetailArticles = (props: IProps) => {
    return (
        <div className={containerStyle}>
            <WideContent>
                <Text as="h2" variant="headline_4" className={headingStyle}>
                    Wiadomości na temat {replaceSpaceWithNonBreakingSpace(props.vendorName)}
                </Text>

                <HorizontalArticleList articles={props.articles} />
            </WideContent>
        </div>
    );
};

const containerStyle = css({
    backgroundColor: "var(--colors-background-200)",
    width: "100%",
    pb: 4.5,
    pt: 2,
    md: {
        pb: 7,
        pt: 4.5
    }
});

const headingStyle = css({
    pb: 2,
    md: {
        pb: 4.5
    }
});
import {css} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";
import {replaceSpaceWithNonBreakingSpace} from "@pg-mono/string-utils";

import {HorizontalArticleList} from "../../../article/components/HorizontalArticleList";
import {IVendorDetailArticle} from "../../actions/fetch_vendor_detail_related_articles";

interface IProps {
    vendorName: string;
    articles: IVendorDetailArticle[];
}

export const VendorDetailArticles = (props: IProps) => {
    return (
        <div className={containerStyle}>
            <WideContent>
                <Text as="h2" variant="headline_4" className={headingStyle}>
                    Wiadomości na temat {replaceSpaceWithNonBreakingSpace(props.vendorName)}
                </Text>

                <HorizontalArticleList articles={props.articles} />
            </WideContent>
        </div>
    );
};

const containerStyle = css({
    backgroundColor: "var(--colors-background-200)",
    width: "100%",
    pb: 4.5,
    pt: 2,
    md: {
        pb: 7,
        pt: 4.5
    }
});

const headingStyle = css({
    pb: 2,
    md: {
        pb: 4.5
    }
});
